module.exports = __webpack_public_path__ + "img/cart.56d44476.svg";